//The clientServiceMapping component declaration
'use strict';
import angular from 'angular';
import './scripts/clientServiceMapping.services';

angular.module('clientServiceMapping', ['clientServiceMapping.services']);
